export const FETCH_CLOUD_CREDENTIALS = 'FETCH_CLOUD_CREDENTIALS';

export const FETCH_CLOUD_CREDENTIALS_PENDING = 'FETCH_CLOUD_CREDENTIALS_PENDING';

export const FETCH_CLOUD_CREDENTIALS_COMPLETE = 'FETCH_CLOUD_CREDENTIALS_COMPLETE';

export const FETCH_CLOUD_CREDENTIALS_ERROR = 'FETCH_CLOUD_CREDENTIALS_ERROR';

export const CREATE_CLOUD_CREDENTIAL = 'CREATE_CLOUD_CREDENTIAL';

export const CREATE_CLOUD_CREDENTIAL_IS_PENDING = 'CREATE_CLOUD_CREDENTIAL_IS_PENDING';

export const CREATE_CLOUD_CREDENTIAL_IS_ERROR = 'CREATE_CLOUD_CREDENTIAL_IS_ERROR';

export const UPDATE_CLOUD_CREDENTIAL = 'UPDATE_CLOUD_CREDENTIAL';

export const UPDATE_CLOUD_CREDENTIAL_IS_PENDING = 'UPDATE_CLOUD_CREDENTIAL_IS_PENDING';

export const UPDATE_CLOUD_CREDENTIAL_IS_ERROR = 'UPDATE_CLOUD_CREDENTIAL_IS_ERROR';

export const SWITCH_CLOUD_CREDENTIAL = 'SWITCH_CLOUD_CREDENTIAL';

export const SWITCH_CLOUD_CREDENTIAL_IS_PENDING = 'SWITCH_CLOUD_CREDENTIAL_IS_PENDING';

export const SWITCH_CLOUD_CREDENTIAL_IS_ERROR = 'SWITCH_CLOUD_CREDENTIAL_IS_ERROR';

export const REMOVE_CLOUD_CREDENTIAL = 'REMOVE_CLOUD_CREDENTIAL';

export const REMOVE_CLOUD_CREDENTIAL_IS_PENDING = 'REMOVE_CLOUD_CREDENTIAL_IS_PENDING';

export const REMOVE_CLOUD_CREDENTIAL_IS_ERROR = 'REMOVE_CLOUD_CREDENTIAL_IS_ERROR';

export const VALIDATE_CLOUD_CREDENTIALS_IS_PENDING = 'VALIDATE_CLOUD_CREDENTIALS_IS_PENDING';

export const VALIDATE_CLOUD_CREDENTIALS_IS_COMPLETE = 'VALIDATE_CLOUD_CREDENTIALS_IS_COMPLETE';

export const VALIDATE_CLOUD_CREDENTIALS_IS_ERROR = 'VALIDATE_CLOUD_CREDENTIALS_IS_ERROR';

export const CLEAR_ERROR = 'CLEAR_CLOUD_CREDENTIAL_ERROR';

export const CLEAN_VALIDATION_FLAGS = 'CLEAN_VALIDATION_FLAGS';

export const FORCE_REDUCER = 'FORCE_REDUCER';
